import { moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewChildren } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { OverlayPanel } from 'primeng/overlaypanel';
import { AppComponent } from 'src/app/app.component';
import { LoginService } from 'src/app/login/login.service';
import { UsersService } from 'src/app/users/users.service';
import { EntitiesService } from '../../configuration/entities.service';
import { ComponentService } from './component.service';
import { ViewComponentAddComponent } from './component/add/view-component-add.component';
import { ViewComponentCardComponent } from './component/card/view-component-card.component';
import { ViewComponentCustomComponent } from './component/custom/view-component-custom.component';
import { ViewComponentFilesComponent } from './component/files/view-component-files.component';
import { ViewComponentFormComponent } from './component/form/view-component-form.component';
import { ViewComponentGalleryComponent } from './component/gallery/view-component-gallery.component';
import { NewViewComponent } from './component/new-view/new-view.component';
import { ViewComponentTableComponent } from './component/table/view-component-table.component';
import { ViewsCustomService } from './views-custom.service';
import { ViewsService } from './views.service';

@Component({
  selector: 'app-view',
  templateUrl: 'view.component.html',
  styleUrls: ['view.component.scss'],
})
export class ViewComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild("op") op: OverlayPanel;
  @ViewChildren("table") tables: Array<ViewComponentTableComponent>;
  @ViewChildren("form") forms: Array<ViewComponentFormComponent>;
  @ViewChildren("card") cards: Array<ViewComponentCardComponent>;
  @ViewChildren("gallery") galleries: Array<ViewComponentGalleryComponent>;
  @ViewChildren("file") files: Array<ViewComponentFilesComponent>;
  @ViewChildren("custom") customs: Array<ViewComponentCustomComponent>;

  @Output() onEvent: EventEmitter<any> = new EventEmitter();

  @Input("code") public code: string;
  @Input("model") public model: any = {};
  @Input("config") public config: any = {};

  public viewOrig: any = {};
  public view: any = {};
  public selectedView: any;
  public showConfigOptions: boolean = false;
  public allowViewPersonalize: boolean = false;
  public allowedLayouts: any[] = [
    { code: "12", name: "1 columna (100%)" },
    { code: "6-6", name: "2 columnas (50%, 50%)" },
    { code: "8-4", name: "2 columnas (66%, 34%)" },
    { code: "9-3", name: "2 columnas (75%, 25%)" },
    { code: "4-8", name: "2 columnas (34%, 66%)" },
    { code: "3-9", name: "2 columnas (25%, 75%)" },
    { code: "4-4-4", name: "3 columnas (34%, 33%, 33%)" }
  ];
  public layout: any[] = [];

  public component: any = null;

  public visibleByOptions: any[] = [
    { code: "all", label: "Todos" },
    { code: "user", label: "El usuario responsable" }
  ];
  public editableByOptions: any[] = [
    { code: "all", label: "Todos" },
    { code: "user", label: "El usuario responsable" }
  ];
  public optionsMetadataTo = [
    { label: "Para todos", value: "all" },
    { label: "Sólo para mí", value: "onlyme" },
    { label: "Para mí y mis subordinados", value: "subordinate" }
  ];

  public entity: any = null;
  public dropdownViews: any[] = [];

  //Permisos
  public personalize_interface: boolean;
  public views_superadmin: boolean;
  public view_organizations: boolean;
  public view_meetings: boolean;
  public create_reports: boolean;
  public roles_configuration: boolean;
  public zonesPermission: boolean;
  public personalized_views_read: boolean;
  public personalized_views_write: boolean;
  public created_by: any;
  private suscription1: any;
  private suscription2: any;

  public isTemplate: boolean = (localStorage.getItem("is_template") == "false" || localStorage.getItem("is_template") == "0" ? false : true);

  constructor(
    private viewsService: ViewsService,
    private viewsCustomService: ViewsCustomService,
    private messageService: MessageService,
    private dialogService: DialogService,
    private loginService: LoginService,
    public componentService: ComponentService,
    private entitiesService: EntitiesService,
    private usersService: UsersService,
  ) {
    //this.formGroup = this.formBuilder.group({});
    //this.formGroup.controls.registerControl('name', new AbstractControl() { Validators: ['', Validators.required]});
    this.suscription1 = this.viewsService.onEditViewChange.subscribe(
      data => {
        this.code = data;
        this.viewsService.getViewConfiguration(this.code).subscribe(
          data => {
            this.viewOrig = JSON.parse(JSON.stringify(data));
            this.selectedView = this.viewOrig.id;
            this.view = data;
            this.toogleConfigOptions();
          });
      });
    this.suscription2 = this.viewsService.onCreateViewChange.subscribe(
      data => {
        this.newView(false);
      });
  }
  ngOnDestroy(): void {
    this.suscription1.unsubscribe();
    this.suscription2.unsubscribe();
  }
  ngOnInit(): void {
    //Recojo el identificador del usuario logeado:
    this.created_by = this.loginService.get("userId");
    //this.view_organizations = this.loginService.hasPermission("ORGANIZATIONS");
    this.view_meetings = this.loginService.hasPermission("MEETINGS");
    this.personalize_interface = this.loginService.hasPermission("PERSONALIZE_INTERFACE");
    this.create_reports = this.loginService.hasPermission("REPORTS_CREATE");
    this.roles_configuration = this.loginService.hasPermission("ROLES_CONFIGURATION");
    this.zonesPermission = this.loginService.hasPermission("ZONES_READ");
    this.personalized_views_read = this.loginService.hasPermission("PERSONALIZED_VIEWS_READ");
    this.personalized_views_write = this.loginService.hasPermission("PERSONALIZED_VIEWS_WRITE");
    this.views_superadmin = this.loginService.hasPermission("VIEWS_SUPERADMIN") || localStorage.getItem("isSuperAdmin") == "true";
    //this.view_attachments_block = this.loginService.hasPermission("ATTACHMENTS");
  }

  ngAfterViewInit():void {
    this.loadView();
  }

  loadView() {
    this.viewsService.getViewConfiguration(this.code).subscribe(
      data => {
        this.viewOrig = JSON.parse(JSON.stringify(data));

        this.selectedView = this.viewOrig.id;
        this.view = data;

        this.viewsService.changeView(this.code);

        //cargamos entidad base si tiene
        if (this.view.configuration?.entity != null) this.loadBaseEntity();

        //si no hay layout, 1 columan
        if (this.view.configuration?.layout == null) this.view.configuration.layout = "12";

        //preparamos layout
        this.prepareLayout();

        //si permite personalizar
        if (this.view.configuration.personalizable != false) {
          this.allowViewPersonalize = true;
        } else {
          this.allowViewPersonalize = false;
        }
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }

  loadBaseEntity() {
    this.entitiesService.getByCode(this.view.configuration.entity).subscribe(
      data => {
        this.entity = data;
        setTimeout(() => {
          this.onEvent.emit({ component: "view", event: "entity-loaded", view: this.view, entity: this.entity });
        },500);
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }

  prepareLayout() {
    let cols = this.view?.configuration?.layout.split("-");
    let nCol = 0;
    this.layout = [];
    cols.forEach(col => {
      var components = this.getComponentsForColumn(nCol);
      this.layout.push({
        id: nCol,
        class: "p-md-" + col,
        components: components
      });
      nCol++;
    });
    //this.onEvent.emit({ component: "view", event: "prepare-layout", view: this.view, entity: this.entity });
  }

  toogleConfigOptions() {
    //TODO: Si es una vista tuya que se pueda editar, se saca las opciones
    // si no, se muestra directamente el popup de crear vista.

    if (this.personalize_interface) {
      if (this.loginService.hasPermission('VIEWS_SUPERADMIN') || this.loginService.get("isSuperAdmin")) {
        this.showConfigOptions = !this.showConfigOptions;
      } else if (this.viewOrig.id < 100000 || (this.viewOrig.user_id != null && this.viewOrig.user_id != this.loginService.get("userId"))) {
        //Es una vista de las originales, no se le permite con
        this.newView(false);
      } else {
        this.showConfigOptions = !this.showConfigOptions;
      }

    }
  }

  itemChange(item, itemComponent) {
    console.info('itemChanged', item, itemComponent);
  }

  itemResize(item, itemComponent) {
    console.info('itemResized', item, itemComponent);
  }

  drop(event, col: any) {
    //moveItemInArray(col.components, event.previousIndex, event.currentIndex);
    if (event.previousContainer === event.container) {
      moveItemInArray(col.components, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }

  onLayoutChange(event) {
    let totalCols = this.view.configuration.layout.split("-").length;
    //si hay componentes sin col, los mandamos a la primera
    this.view.configuration.components.forEach(component => {
      if (component.layout_col != null && component.layout_col > totalCols - 1) component.layout_col = 0;
    });
    this.prepareLayout();
  }

  getComponentsForColumn(nCol: number) {
    let components = this.view?.configuration?.components.filter(m => {
      return m.layout_col == nCol || (nCol == 0 && m.layout_col == null);
    });
    return components;
  }

  onComponentEvent(event: any) {
    if (event.event == "view-save") {
      //this.save();
    } else if (event.event == "component-left") {
      let previousIndex = event.index;
      let currentIndex = previousIndex - 1;
      if (currentIndex >= 0 && previousIndex >= 0) moveItemInArray(this.view.configuration.components, previousIndex, currentIndex);
    } else if (event.event == "component-right") {
      let previousIndex = event.index;
      let currentIndex = previousIndex + 1;
      if (currentIndex >= 0 && previousIndex >= 0) moveItemInArray(this.view.configuration.components, previousIndex, currentIndex);
    } else {
      this.onEvent.emit(event);
    }
  }

  save() {
    //pasamos componentes del layout a la configuracion
    let components: any[] = [];
    this.layout.forEach(col => {
      col.components.forEach(component => {
        component.layout_col = col.id;
        components.push(component);
      });
    });
    this.view.configuration.components = components;

    

    //cualqueir cambio de vista se guarda siempre en el custom
    if (this.view.id > 1000000) {
      //quitamos info de field antes de guardar
      let saveView = JSON.parse(JSON.stringify(this.view));
      saveView.configuration.components.forEach((component) => {
        component.fields?.forEach((field) => {
          delete field.entityField;
        });
      });

      this.viewsCustomService.saveView(this.view.id, saveView).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: 'success', summary: 'Configuración guardada' });
          this.showConfigOptions = false;
          this.prepareLayout();
          location.reload();
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      )
    } else {
      this.viewsService.save(this.view.id, this.view).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: 'success', summary: 'Configuración guardada' });
          this.showConfigOptions = false;
          this.prepareLayout();
          location.reload();
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
          )
    }
  }

  cancel() {
    this.view = this.viewOrig;
    this.showConfigOptions = false;
    location.reload();
  }

  fireEvent(component: string, event: string, args: any = null) {
    var table = this.tables.filter(m => m.component.code == component);
    var card = this.cards.filter(m => m.component.code == component);
    var gallery = this.galleries.filter(m => m.component.code == component);
    var file = this.files.filter(m => m.component.code == component);
    var custom = this.customs.filter(m => m.component.code == component);

    if (card.length > 0) {
      card[0].fireEvent(component, event, args);
    } else if (gallery.length > 0) {
      gallery[0].fireEvent(component, event, args);
    } else if (table.length > 0) {
      table[0].fireEvent(component, event, args);
    } else if (file.length > 0) {
      file[0].fireEvent(component, event, args);
    } else if (custom.length > 0) {
      custom[0].fireEvent(component, event, args);
    } else {
      var form = this.forms.filter(m => m.component.code == component);
      if (form.length > 0) {
        form[0].fireEvent(component, event, args);
      }
    }

  }

  getComponent(component: string): any {

    var table = this.tables.filter(m => m.component.code == component);
    var card = this.cards.filter(m => m.component.code == component);
    var gallery = this.galleries.filter(m => m.component.code == component);
    var file = this.files.filter(m => m.component.code == component);
    var custom = this.customs.filter(m => m.component.code == component);
    var form = this.forms.filter(m => m.component.code == component);

    let ret: any = null;
    if (card.length > 0) {
      ret = card[0];
    } else if (gallery.length > 0) {
      ret = gallery[0];
    } else if (table.length > 0) {
      ret = table[0];
    } else if (file.length > 0) {
      ret = file[0];
    } else if (custom.length > 0) {
      ret = custom[0];
    } else if (form.length > 0) {
      ret = form[0];
    }
    return ret;
  }

  getComponentForm(component: string): FormGroup {
    var form = this.forms.filter(m => m.component.code == component);
    let ret: FormGroup = null;
    if (form.length > 0) ret = form[0].form;
    return ret;
  }

  addComponent() {
    const ref = this.dialogService.open(ViewComponentAddComponent, {
      data: {
        view_code: this.code
      },
      header: "Añadir componente",
      width: '600px'
    });
    ref.onClose.subscribe((data: any) => {
      if (data) {
        let component = data.base_component.configuration;
        component.layout_col = 0;
        component.base_component_code = data.base_component.code;
        this.layout[0].components.push(component);
      }
    })
  }

  removeComponent(col, component, i) {
    col.components.splice(i, 1);
  }

  showComponentConfigOP($event, component: any) {
    this.component = component;
    if (this.op.overlayVisible) {
      this.op.hide();
    } else {
      this.op.show($event);
    }
  }
  getEntityFromComponent() {
    return this.entity;
  }

  getEntityBaseName(plural: boolean = false, capitalize: boolean = false) {
    let title = "";
    if (this.entity?.name != null) {
      if (plural) {
        title = this.entity.name_plural;
      } else {
        title = this.entity.name;
      }
      title = title.toLowerCase();
      if (capitalize) title = title[0].toUpperCase() + title.substring(1);
    }
    return title;
  }
  getViewCodeName() {
    return this.view.code + " - " + this.view.name + " - " + this.view.id;
  }
  getViewIsFormEdit() {
    return this.view.code.includes("edit");
  }

  //Valida que TODOs los formularios de la vista son válidos
  getAllFormsFromViewValid() {
    var invalidsForm = this.forms.filter(m => m.form.valid == false);
    if (invalidsForm.length > 0) {
      console.log(this.forms);//pintamos los informes para poder ver cual es el invalido.
    }
    return (invalidsForm.length > 0 ? false : true);
    
  }

  newView(edit) {
    const ref = this.dialogService.open(NewViewComponent, {
      data: {
        view: this.viewOrig,
        edit: edit
      },
      header: edit ? "Editar vista personalizada" : "Crear nueva vista",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      this.loadViewsDropdown();
      if (data) {
        let component = data.configuration;
        component.layout_col = 0;
        component.base_component_code = data.code;
        this.layout[0].components.push(component);
        this.loadViewsDropdown();
        location.reload();
      }
    })
  }
  editView() {
    this.showConfigOptions = !this.showConfigOptions;
    this.op.hide();
  }
  opToggleTitle(op, $event, component) {
    this.component = component;
    op.toggle($event);
  }
  opToggle(op, $event) {
    this.loadViewsDropdown()
    op.toggle($event);
  }
  tableColumnsAdjust() {
    if (!this.component) return;
    let component:ViewComponentTableComponent = this.getComponent(this.component.code);
    if (component) component.autoSizeCols();
  }
  delete() {
    this.viewsCustomService.delete(this.view.id).subscribe(
      data => {
        this.messageService.add({ severity: "success", detail: "Vista eliminada correctamente." });
        location.reload();
      },
      error => {
        this.messageService.add({ severity: "error", detail: error.error.title });
      }
    );
    /*
    this.confirmationService.confirm({
      message: '¿Quieres borrar la vista ' + this.view.name + '? Se procederá a asignar la vista base para todos los usuarios que la tuviesen seleccionada.',
      header: 'Confirmación de borrado',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.viewsCustomService.delete(this.view.id).subscribe(
          data => {
            this.messageService.add({ severity: "success", detail: "Vista eliminada correctamente." });
            location.reload();
          },
          error => {
            this.messageService.add({ severity: "error", detail: error.error.title });
          }
        );
      }
    });
    */

  }
  loadViewsDropdown() {
    this.viewsService.viewsCombo({ code: this.code }).subscribe(
      data => {
        this.dropdownViews = data;
        if (this.personalized_views_write) {
          this.dropdownViews.push({ id: -1, name: "*** Crear nueva vista ***" });
        }
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }

  changeCurrentView() {
    //Éste método utilizará el id de la view seleccionada (selectedView) para guardarlo en el metadata del usuario (userId).
    if (this.selectedView != -1) {
      this.usersService.changeCurrentView(this.loginService.get("userId"), this.selectedView).subscribe(
        data => {
          if (data) {
            this.viewsService.removeViewConfigurationFromCache(this.selectedView.code);
            location.reload();
          }
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }/* else {
      this.newView(false);
    }*/
  }
}
